import { PageLayout } from '../components/layout/PageLayout';
import { useQuota } from '../hooks';

interface QuotaItem { quota: number; used: number; remaining: number; }
interface QuotaData {
  year: number;
  sick: QuotaItem; personal: QuotaItem; vacation: QuotaItem;
}

function Bar({ label, q }: { label: string; q: QuotaItem }) {
  const pct = q.quota > 0 ? Math.min(100, (q.used / q.quota) * 100) : 0;
  const color = pct >= 100 ? 'bg-red-500' : pct >= 80 ? 'bg-gold' : 'bg-brand-gradient';
  return (
    <div className="card p-4">
      <div className="flex justify-between mb-2">
        <span className="font-medium">{label}</span>
        <span className="text-sm text-gray-600">
          ใช้ {q.used} / {q.quota} วัน (เหลือ {q.remaining})
        </span>
      </div>
      <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
        <div className={`h-full ${color}`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}

export function Quota() {
  const { data, isLoading } = useQuota() as { data: QuotaData | undefined; isLoading: boolean };
  if (isLoading) return <PageLayout title="สิทธิ์การลา"><p>กำลังโหลด...</p></PageLayout>;
  if (!data) return <PageLayout title="สิทธิ์การลา"><p>ไม่มีข้อมูล</p></PageLayout>;

  return (
    <PageLayout title="สิทธิ์การลา">
      <p className="text-sm text-gray-600 mb-3">ปี {data.year}</p>
      <div className="space-y-3">
        <Bar label="ลาป่วย" q={data.sick} />
        <Bar label="ลากิจ" q={data.personal} />
        <Bar label="ลาพักร้อน" q={data.vacation} />
      </div>
    </PageLayout>
  );
}
